module.exports = __webpack_public_path__ + "img/hr-heated-corner-down-right-4.351a4603.png";